/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
 
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const NotransitActions = (props) => {
    const handleOverspeedClick = (e) => {
        e.stopPropagation();

        //console.log("Overspeed ",props.data);
        if(props.data.dept_code == 'LOG-PRT')
        {
            if(props.data.show_legs == 1)
            {
                props.context.componentParent.onShowTransitKpi(props);
            }
            else
            {
                props.context.componentParent.onShowTransitKpi(0);
            }
        }
        else
        {
            props.context.componentParent.onShowTransitKpi(props);
        }
    };
    

    return (
        <div>
			<button onClick={handleOverspeedClick} className="custom-btn f22 label label-success" title="No Transit Delay" style={{color:"#ccc"}}><i className="icofont icofont-clock-time"></i> &nbsp;</button>
            
        </div>
    );
};

export default NotransitActions;
